// extracted by mini-css-extract-plugin
export var cardIcon = "_6e-4";
export var checkboxCard = "_6e-0";
export var checkboxCardSelected = "_6e-3";
export var disabled = "_6e-1";
export var outerBorder = "_6e-2";
export var spacerMedium = "_6e-7";
export var spacerSmall = "_6e-6";
export var spacerXsmall = "_6e-5";